import { render } from "./Home.vue?vue&type=template&id=09857ee0&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=09857ee0&lang=less&scoped=true"

import exportComponent from "C:\\project\\famous-build-en\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09857ee0"]])

export default __exports__